<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  plan: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const includedTickets = computed(
  () => props.plan.included_tickets ?? props.plan.includedTickets
);

const overageRate = computed(
  () => props.plan.overage_rate ?? props.plan.overageRate
);

const seatCap = computed(() => props.plan.seat_cap ?? props.plan.seatCap);

const contactSales = computed(
  () => props.plan.contact_sales ?? props.plan.contactSales
);

const UNLIMITED_SEAT_THRESHOLD = 100000;

const seatLabel = computed(() => {
  if (!seatCap.value || seatCap.value >= UNLIMITED_SEAT_THRESHOLD) {
    return t('BILLING_SETTINGS.PLANS.SEATS_UNLIMITED');
  }

  return t('BILLING_SETTINGS.PLANS.SEATS', { count: seatCap.value });
});

const features = computed(() => {
  const items = [];

  if (!contactSales.value && includedTickets.value != null) {
    items.push(
      t('BILLING_SETTINGS.PLANS.INCLUDED_TICKETS', {
        count: includedTickets.value,
      })
    );
  }

  if (!contactSales.value && overageRate.value != null) {
    items.push(
      t('BILLING_SETTINGS.PLANS.OVERAGE', { rate: overageRate.value })
    );
  }

  items.push(seatLabel.value);
  items.push(t('BILLING_SETTINGS.CURRENT_PLAN.ALL_FEATURES'));

  return items;
});
</script>

<template>
  <ul class="grid gap-2 sm:grid-cols-2">
    <li
      v-for="feature in features"
      :key="feature"
      class="flex items-start gap-2 text-sm text-n-slate-11"
    >
      <span
        class="i-lucide-check mt-0.5 size-4 shrink-0 text-n-teal-10"
        aria-hidden="true"
      />
      <span>{{ feature }}</span>
    </li>
  </ul>
</template>
